var _path, _path2, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatusIndicatorGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#73a341",
    d: "M112.45,165.07H385.84a72.37,72.37,0,0,1,72.37,72.37h0a72.37,72.37,0,0,1-72.37,72.37H112.45a72.37,72.37,0,0,1-72.37-72.37h0A72.37,72.37,0,0,1,112.45,165.07Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#e4e5e7",
    d: "M112.45,165.07h201V309.81h-201a72.37,72.37,0,0,1-72.37-72.37h0A72.37,72.37,0,0,1,112.45,165.07Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#d2d2d1",
    x: 168.74,
    y: 165.07,
    width: 144.74,
    height: 144.74
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusIndicatorGreen);
export default __webpack_public_path__ + "static/media/statusIndicatorGreen.d4996ede.svg";
export { ForwardRef as ReactComponent };